import * as mobx from 'mobx';
import { IConnectionAttendeeDTO } from '../../../api/connections.dao';
import { ConnectionEntity } from '../abstract-connection.entity';

const key = 'meetingConnectionId';

export class AttendeeMeetingConnection extends ConnectionEntity<IConnectionAttendeeDTO> {
    public static create(attendeeProps: IConnectionAttendeeDTO): AttendeeMeetingConnection {
        return new AttendeeMeetingConnection(attendeeProps);
    }
    public getId() {
        return this.getProps().attendeeId;
    }

    public toDTO() {
        const _dto = this.getProps();

        if (this.hasAssignedConnection()) {
            _dto[key] = this.getAssignedConnection();
        } else {
            delete _dto[key];
        }

        return _dto as IConnectionAttendeeDTO;
    }

    @mobx.observable
    private [key]: {};

    constructor({ meetingConnectionId, ...rest }: IConnectionAttendeeDTO) {
        super(key, rest);

        if (meetingConnectionId) this.assignConnection(meetingConnectionId);
    }

    public getFirstName(): string {
        return this.getProps().firstName;
    }
    public getLastname(): string {
        return this.getProps().lastName;
    }
}
